// import useTableStore from "@/stores/tableStore";
import { useAppStore } from "@/stores/appStore";
import { config_base } from "@/data/config_base";

export const useContent = () => {
	const { productOptions } = useAppStore();
	const data = config_base;

	const getListConfigurationSteps = () => {
		return data.configurator.steps;
	};

	// const getCurrentStep = () => {
	//   return data.configurator.steps[step];
	// };

	const getCategory = () => {
		return data.configurator.categories;
	};

	const getGates = () => {
		return data.configurator.gates;
	};

	const getPillars = () => {
		return data.configurator.pillars;
	};

	const getShapes = () => {
		return data.configurator.shapes;
	};

	const getModifiers = () => {
		return data.configurator.modifiers;
	};

	const getMaterials = (items) => {
		const materials = items.map((item) => {
			const itemMaterialsData = data.configurator.materials.filter((material) => item.materials.includes(material.id));

			//add target part for materials to identify which item the material belongs to
			const itemMaterials = itemMaterialsData.map((material) => ({ ...material, ...{ target: item.id } }));

			const modifierMaterials = item.modifiers
				.filter((modifierId) => item.selectedModifiers?.some((selected) => selected.id === modifierId))
				.map((modifierId) => {
					const modifier = data.configurator.modifiers.find((x) => x.id === modifierId);

					const modifierMaterialsData = data.configurator.materials.filter((material) =>
						modifier.materials?.includes(material.id)
					);

					//add target part for materials to identify which item the material belongs to
					const modifierMaterials = modifierMaterialsData.map((material) => ({
						...material,
						...{ target: modifierId },
					}));

					return {
						id: modifier.id,
						name: modifier.title,
						type: modifier.type,
						materials: modifierMaterials,
					};
				});

			return {
				id: item.id,
				name: item.title,
				type: item.type,
				materials: itemMaterials,
				modifierMaterials: modifierMaterials,
			};
		});

		return materials;
	};

	// const getCurrentShapeData = () => {
	//   return data.configurator.shapes.find((x) => x.id === productOptions.doorStyles.shape);
	// };

	// const getDimensions = () => {
	//   const currentShape = data.configurator.shapes.find((x) => x.id === shape)!;
	//   const currentMaterial = currentShape.dimensions[tableMaterial as keyof typeof currentShape.dimensions] as DimensionsRanges;

	//   return { ...currentMaterial, step: currentShape.dimensions.step };
	// };

	// const getMaterialsTabltop = () => {
	//   const materials = data.configurator.materials.filter((x) => x.id !== "steel");
	//   const materialColors = materials.find((x) => x.id === tableMaterial)?.colors;
	//   const choosenMaterial = materialColors?.find((x) => x.id === tableColor);

	//   return { materials, materialColors, choosenMaterial };
	// };

	// const getCurrentLeg = () => {
	//   const currentLeg = data.configurator.legs?.find((x) => x.id === leg);

	//   return currentLeg;
	// };

	// const getLegs = () => {
	//   const currentShape = getCurrentShapeData();

	//   if (currentShape?.group === "DIM") {
	//     return data.configurator.legs.filter((x) => x.conditions.tableGroup === "DIM" && x.material === legMaterial);
	//   } else {
	//     return data.configurator.legs.filter((x) => x.conditions.tableGroup === "LW" && x.material === legMaterial);
	//   }
	// };

	// const getMaterialsLeg = () => {
	//   const currentLeg = getCurrentLeg();
	//   const materials = data.configurator.materials.filter((x) => x.id !== "ceramic");
	//   const materialColors = data.configurator.materials.find((x) => x.id === legMaterial)?.colors;
	//   const choosenMaterial = data.configurator.materials.find((x) => x.id === currentLeg?.material)?.colors.find((x) => x.id === legColor);
	//   return { materials, materialColors, choosenMaterial };
	// };

	const getDashboardMenu = () => {
		return data.dashboard.menu;
	};

	return {
		getCategory,
		getGates,
		getShapes,
		getListConfigurationSteps,
		getDashboardMenu,
		getModifiers,
		getPillars,
		getMaterials,
	};
};
